import { render, staticRenderFns } from "./goods-show.vue?vue&type=template&id=47566239&scoped=true"
import script from "./goods-show.vue?vue&type=script&lang=js"
export * from "./goods-show.vue?vue&type=script&lang=js"
import style0 from "./goods-show.vue?vue&type=style&index=0&id=47566239&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47566239",
  null
  
)

export default component.exports